module.exports = __webpack_public_path__ + "img/profile--upload-picture.8aac8b33.svg";